import { i18n } from "@/i18n"

export enum ProductKey {
  Mini = "mini",
  Small = "small",
  Medium = "medium",
  LargeTest = "large",
  XLarge = "xlarge",
  Guests2000 = "2000-guests",
  XXLarge = "xxlarge",
  Festival = "festival",
  CorporateStandard = "corporate-standard",
  CorporateStandardPlus = "corporate-standard-plus",
  CorporatePremium = "corporate-premium",
  CorporatePremiumPlus = "corporate-premium-plus",
  CorporateMax = "corporate-max",
  Classic = "classic",
  Signature = "signature",
  Luxe = "luxe",
  BusinessGold = "business-gold",
  BusinessSilver = "business-silver",
  BusinessPlatinum = "business-platinum",
  BusinessMultiSilver = "business-multi-silver",
  BusinessMultiGold = "business-multi-gold",
  BusinessMultiPlatinum = "business-multi-platinum",
  ClassicPlus = "classic-plus",
  MerryBusiness = "merry-business",
}

// eslint-disable-next-line ts/no-namespace
export namespace ProductTypes {
  const { t } = i18n.global

  const productLabels: Record<ProductKey, string> = {
    [ProductKey.Mini]: t("product_type.mini"),
    [ProductKey.Small]: t("product_type.small"),
    [ProductKey.Medium]: t("product_type.medium"),
    [ProductKey.LargeTest]: t("product_type.large"),
    [ProductKey.XLarge]: t("product_type.xlarge"),
    [ProductKey.Guests2000]: t("product_type.2000-guests"),
    [ProductKey.XXLarge]: t("product_type.xxlarge"),
    [ProductKey.Festival]: t("product_type.festival"),
    [ProductKey.CorporateStandard]: t("product_type.corporate-standard"),
    [ProductKey.CorporateStandardPlus]: t("product_type.corporate-standard-plus"),
    [ProductKey.CorporatePremium]: t("product_type.corporate-premium"),
    [ProductKey.CorporatePremiumPlus]: t("product_type.corporate-premium-plus"),
    [ProductKey.CorporateMax]: t("product_type.corporate-max"),
    [ProductKey.Classic]: t("product_type.classic"),
    [ProductKey.Signature]: t("product_type.signature"),
    [ProductKey.Luxe]: t("product_type.luxe"),
    [ProductKey.BusinessGold]: t("product_type.business-gold"),
    [ProductKey.BusinessSilver]: t("product_type.business-silver"),
    [ProductKey.BusinessPlatinum]: t("product_type.business-platinum"),
    [ProductKey.BusinessMultiSilver]: t("product_type.business-multi-silver"),
    [ProductKey.BusinessMultiGold]: t("product_type.business-multi-gold"),
    [ProductKey.BusinessMultiPlatinum]: t("product_type.business-multi-platinum"),
    [ProductKey.ClassicPlus]: t("product_type.classic-plus"),
    [ProductKey.MerryBusiness]: t("product_type.merry-business"),
  }

  export function getLabel(type?: ProductKey, fallback: string = t("product_type.custom")) {
    if (!type)
      return fallback

    return productLabels[type] || fallback
  }
}
